/**
 * Normalizes a Dutch postal code to the canonical `1234AB` form:
 * strips all whitespace and uppercases. Use everywhere a postal code is sent
 * to the backend so the format is consistent across service and mappers.
 */
export function normalizePostalCode(postalCode: string): string {
  return postalCode.replace(/\s+/g, '').toUpperCase();
}
